import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Previsions from "./pages/Previsions";
import InvestorOnePager from "./pages/InvestorOnePager";
import VisionPage from "./pages/VisionPage";
import MarchePage from "./pages/MarchePage";
import ProduitPage from "./pages/ProduitPage";
import ResumeExecutifPage from "./pages/ResumeExecutifPage";
import PaiementsPage from "./pages/PaiementsPage";
import GTMPage from "./pages/GTMPage";
import ModelePage from "./pages/ModelePage";
import OrganisationPage from "./pages/OrganisationPage";
import RoadmapPage from "./pages/RoadmapPage";
import ValorisationPage from "./pages/ValorisationPage";
import LeveeFondsPage from "./pages/LeveeFondsPage";
import ProprieteIntellectuellePage from "./pages/ProprieteIntellectuellePage";
import PlanExecutionPage from "./pages/PlanExecutionPage";
import MarcheGarderiesPage from "./pages/MarcheGarderiesPage";
import PrintAllPages from "./pages/PrintAllPages";
import InvestDeckPage from "./pages/InvestDeckPage";
import RondeSeedPage from "./pages/RondeSeedPage";
import GateKeeper from "./components/GateKeeper";
import TrackingProvider from "./components/TrackingProvider";
import AdminAnalytics from "./pages/AdminAnalytics";
import PresentationEcolunchPage from "./pages/PresentationEcolunchPage";
import EcosystemePortailsPage from "./pages/EcosystemePortailsPage";
import OrganigrammePage from "./pages/OrganigrammePage";
import { LanguageProvider } from "./contexts/LanguageContext";
import { PresentationProvider } from "./contexts/PresentationContext";
import { ScenarioProvider } from "./contexts/ScenarioContext";

function App() {
  return (
    <LanguageProvider>
      <ScenarioProvider>
      <PresentationProvider>
        <div className="App">
          <BrowserRouter>
            <GateKeeper>
              <TrackingProvider>
              <Routes>
                {/* Admin analytics - hidden, separate auth */}
                <Route path="/admin/analytics" element={<AdminAnalytics />} />
                {/* Print route - outside Layout for clean printing */}
                <Route path="/print-all" element={<PrintAllPages />} />
                {/* Invest Deck - standalone shareable page */}
                <Route path="/invest-deck" element={<InvestDeckPage />} />
                {/* Ronde Seed - standalone investor memo */}
                <Route path="/ronde-seed" element={<RondeSeedPage />} />
                {/* Iframe pages - external apps embedded */}
                <Route path="/presentation-ecolunch" element={<PresentationEcolunchPage />} />
                <Route path="/ecosysteme-portails" element={<EcosystemePortailsPage />} />
                <Route path="/organigramme" element={<OrganigrammePage />} />
                
                <Route path="/" element={<Layout />}>
                  {/* PARTIE I - STRATÉGIE */}
                  <Route index element={<Home />} />
                  <Route path="/marche" element={<MarchePage />} />
                  <Route path="/marche-garderies" element={<MarcheGarderiesPage />} />
                  <Route path="/vision" element={<VisionPage />} />
                  
                  {/* PARTIE II - TECHNOLOGIE */}
                  <Route path="/produit" element={<ProduitPage />} />
                  <Route path="/propriete-intellectuelle" element={<ProprieteIntellectuellePage />} />
                  <Route path="/paiements" element={<PaiementsPage />} />
                  
                  {/* PARTIE III - EXÉCUTION */}
                  <Route path="/plan-execution" element={<PlanExecutionPage />} />
                  <Route path="/gtm" element={<GTMPage />} />
                  <Route path="/roadmap" element={<RoadmapPage />} />
                  
                  {/* PARTIE IV - FINANCES */}
                  <Route path="/resume-executif" element={<ResumeExecutifPage />} />
                  <Route path="/modele" element={<ModelePage />} />
                  <Route path="/organisation" element={<OrganisationPage />} />
                  <Route path="/valorisation" element={<ValorisationPage />} />
                  <Route path="/levee-de-fonds" element={<LeveeFondsPage />} />
                  <Route path="/synthese-investisseur" element={<InvestorOnePager />} />
                  <Route path="/previsions" element={<Previsions />} />
                </Route>
              </Routes>
              </TrackingProvider>
            </GateKeeper>
          </BrowserRouter>
        </div>
      </PresentationProvider>
      </ScenarioProvider>
    </LanguageProvider>
  );
}

export default App;
